import { productApi } from '@/api'
import { SHARED } from '@/constants/constants'
import { ProductDealTypeString } from '@/constants/enums'

const MODULE_NAME = 'product/'

//define action name
const A_PRODUCTS_BY_CATEGORY = 'getProductListByCategory'
const A_PRODUCTS_BY_DEAL_TYPE = 'getProductListByDealType'
const A_WISHLIST_PRODUCT = 'addProductToWishlist'
//define mutations name
const M_PRODUCTS_BY_CATEGORY = 'getProductListByCategoryComplete'
const M_PRODUCTS_BY_DEAL_TYPE = 'getProductListByDealTypeComplete'
const M_WISHLIST_PRODUCT = 'addProductToWishlistComplete'
//define dispatch name
export const PRODUCT_PRODUCTS_BY_CATEGORY = MODULE_NAME + A_PRODUCTS_BY_CATEGORY
export const PRODUCT_PRODUCTS_BY_DEAL_TYPE = MODULE_NAME + A_PRODUCTS_BY_DEAL_TYPE

const state = {
  categoryProduct: [],
  flashDealProduct: [],
  flashDealEndDate: SHARED.TODAY_END_DATE,
  hotDealProduct: [],
  topPickProduct: []
}

const getters = {}

const actions = {
  [A_PRODUCTS_BY_CATEGORY]({ commit }, { obj }) {
    productApi.getProductByCategory(obj).then(
      (data) => {
        let result = data
        commit(M_PRODUCTS_BY_CATEGORY, { result })
      },
      (error) => {
        let result = error
        commit(M_PRODUCTS_BY_CATEGORY, { result })
      }
    )
  },
  [A_PRODUCTS_BY_DEAL_TYPE]({ commit }, { obj }) {
    productApi.getProductByDealType(obj).then(
      (data) => {
        let result = data
        commit(M_PRODUCTS_BY_DEAL_TYPE, { result })
      },
      (error) => {
        let result = error
        commit(M_PRODUCTS_BY_DEAL_TYPE, { result })
      }
    )
  },
  [A_WISHLIST_PRODUCT]({ commit }, { obj }) {
    productApi.addProductToWishlist(obj).then(
      (data) => {
        let result = data
        commit(M_WISHLIST_PRODUCT, { result })
      },
      (error) => {
        let result = error
        commit(M_WISHLIST_PRODUCT, { result })
      }
    )
  }
}

const mutations = {
  [M_PRODUCTS_BY_CATEGORY](state, { result }) {
    if (result.products != null) {
      state.categoryProduct = result.products
    }
  },
  [M_PRODUCTS_BY_DEAL_TYPE](state, { result }) {
    if (result.details != null) {
      if (result.type.toLowerCase() == ProductDealTypeString.FLASH_DEALS.toLowerCase()) {
        state.flashDealProduct = result.details.products
        var dt = new Date()
        dt.setHours(dt.getHours() + result.details.remaining_hour)
        dt.setMinutes(dt.getHours() + result.details.remaining_minute)
        dt.setSeconds(dt.getHours() + result.details.remaining_second)
        state.flashDealEndDate = dt
      } else if (result.type.toLowerCase() == ProductDealTypeString.HOT_DEALS.toLowerCase()) {
        state.hotDealProduct = result.details.products
      } else if (result.type.toLowerCase() == ProductDealTypeString.TOP_PICKS.toLowerCase()) {
        state.topPickProduct = result.details.products
      }
    } else if (result.type.toLowerCase() == ProductDealTypeString.TOP_PICKS.toLowerCase()) {
      state.topPickProduct = []
    }
  },
  [M_WISHLIST_PRODUCT](/*state, { result }*/) {
    console.log('Push Item Into Wishlist')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
